import { render, staticRenderFns } from "./DepositSummary.vue?vue&type=template&id=20c2c3ab"
import script from "./DepositSummary.vue?vue&type=script&lang=js"
export * from "./DepositSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports